import queryString from 'query-string';

import { createPropsToQueryParamsMapper } from 'utils/createPropsToQueryParamsMapper';
import * as Types from 'types';

import { BrowseFilters } from './types';
import { updateParam } from 'apps/browse/utils/updateParam';

export const PER_PAGE = process.env.NODE_ENV === 'development' ? 9 : 42;

type MapperType = {
  type: Types.ArtistTypes;
  order: BrowseFilters.OrderTypes;
};

export const mapper = createPropsToQueryParamsMapper<MapperType>(
  {
    type: (value, queryParams) => {
      queryParams['filter'] = updateParam(
        queryParams['filter'],
        Object.keys(BrowseFilters.LABELED_ARTIST_TYPES),
        [value, 'artists'],
      );
      return queryParams;
    },
    order: (value, queryParams) => {
      switch (value) {
        case 'alphabetical':
          queryParams['order'] = 'alphabetical';
          delete queryParams['direction'];
          break;

        case 'collectors':
          queryParams['order'] = 'collectors';
          queryParams['direction'] = 'desc';
          break;
        case 'followers':
          queryParams['order'] = 'followers';
          queryParams['direction'] = 'desc';
          break;
        case 'popularity':
          queryParams['order'] = 'rank';
          queryParams['direction'] = 'desc';
          break;
        case 'date':
        default:
          queryParams['order'] = 'date';
          queryParams['direction'] = 'desc';
          break;
      }
      return queryParams;
    },
  },
  (params) => {
    if (typeof params['filter'] === 'string') {
      params['filter'] = params['filter'].split(',');
    }
    return params;
  },
  (params) => {
    if (Array.isArray(params['filter'])) {
      params['filter'] = params['filter'].join(',');
    }
    return params;
  },
);

export const getPriceQueryParam = (
  defaultValue: [number, number],
): [number, number] => {
  const queryParams = queryString.parse(document.location.search);
  const value = queryParams['price'];
  if (typeof value === 'string') {
    const parts = value.split('-');
    return [parseInt(parts[0], 10), parseInt(parts[1], 10)];
  } else {
    return defaultValue;
  }
};
